import { BRAND_GRADIENT } from '@shared/styles/brand';

interface Props {
  /** Progress 0–100 (clamped). */
  value: number;
  /** Bar height in px (Figma "Progress Stepper" = 4). */
  height?: number;
  className?: string;
}


/**
 * Thin rounded progress bar matching the Figma "Progress Stepper": track on `--canvas` (#ECF1FC),
 * brand-gradient fill, smooth width transition. Used by the CQG connect dialog's import progress.
 */
export function ProgressBar({ value, height = 4, className = '' }: Props) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
      className={`w-full overflow-hidden ${className}`}
      style={{ height, borderRadius: 200, background: 'var(--canvas)' }}
    >
      <div
        className="h-full transition-[width] duration-500 ease-out"
        style={{ width: `${pct}%`, background: BRAND_GRADIENT, borderRadius: 200 }}
      />
    </div>
  );
}
